<template>
  <component
    :is="tag"
    class="text"
    :class="[
      variantClasses,
      colorClasses
    ]"
  >
    <slot />
  </component>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  variant: {
    type: String,
    default: 'body',
    validator: val => ['body', 'body-large', 'body-small', 'label', 'caption', 'ui-button', 'ui-label', 'ui-caption'].includes(val)
  },
  tag: {
    type: String,
    default: 'p',
    validator: val => ['p', 'span', 'div', 'label'].includes(val)
  },
  color: {
    type: String,
    default: 'default',
    validator: val => ['default', 'primary', 'muted', 'subtle', 'accent', 'coral', 'orange', 'success', 'warning', 'error'].includes(val)
  }
})

const variantClasses = computed(() => {
  switch (props.variant) {
    case 'body-large':
      return 'text-body-large leading-relaxed font-regular'
    case 'body-small':
      return 'text-body-small leading-normal font-regular'
    case 'label':
      return 'text-label font-medium'
    case 'caption':
      return 'text-xs leading-normal font-regular'
    case 'ui-button':
      return 'text-ui-button'
    case 'ui-label':
      return 'text-ui-label'
    case 'ui-caption':
      return 'text-ui-caption'
    case 'body':
    default:
      return 'text-body font-regular'
  }
})

const colorClasses = computed(() => {
  switch (props.color) {
    case 'primary':
      return 'text-on-surface'
    case 'muted':
      return 'text-on-surface-variant'
    case 'subtle':
      return 'text-outline'
    case 'accent':
      return 'text-primary'
    case 'coral':
      return 'text-secondary'
    case 'orange':
      return 'text-tertiary'
    case 'success':
      return 'text-success'
    case 'warning':
      return 'text-warning'
    case 'error':
      return 'text-error'
    case 'default':
    default:
      return 'text-on-surface'
  }
})
</script>
